// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"RegistrationForm_placeholder_2XGhi","submit":"RegistrationForm_submit_13u-5"};